import React, { useEffect, useState, ReactNode, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import moHuring from '../store/huring';

interface IProps {
  list: any[]
}
interface IState { }

const HuringChart = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const huringRef = useRef<any>(null);
  const { huringList } = moHuring;
  let chart: any = null;
  const { list } = props;

  const xData = useMemo(() => {
    const rList: any = [];
    const xList: any = [];
    const nList: any = [];
    list.forEach((res: any) => {
      rList.push(res.revenue);
      xList.push(res.quarter);
      nList.push(res.count);
    });
    return { rList, xList, nList };
  }, [list]);

  const colorList = [Color.primary, Color.two, Color.secondary];

  const render = () => {
    if (chart) chart.dispose();
    huringRef.current.style.width = 100 / huringList + 'px';
    chart = init(huringRef.current);
    const option = {
      color: colorList,
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
          label: { show: true },
        },
        formatter: (parmes: any) => {
          let htl = `<p  style="font-family: 'PingFang SC';text-align:left">${parmes[0].name}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                         justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${colorList[element.seriesIndex]};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC'">${element.seriesName}</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';padding-top:4px;flex:1;text-align:right">
                        ${element.value ? round(element.value, 2).toLocaleString() : '-'}
                      </span >
                   </p > `;
          });
          return htl;
        },
      },
      legend: {
        data: ['营业收入(亿元)', '招聘量(个)'],
        bottom: 0,
        icon: 'circle',
      },
      grid: {
        left: 30,
        right: 10,
        bottom: 45,
        top: 10,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xData.xList,
        axisTick: { show: false },
        axisLine: {
          lineStyle: { color: Color.ccc },
        },
        axisLabel: {
          color: Color.blackColor(0.85),
          rotate: 90,
          fontFamily: 'Roboto',
        },
      },
      yAxis: [
        {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: (val: number) => {
              if (val === 0) return 0;
              return `${Number(val).toLocaleString()} `;
            },
            fontSize: 10,
            color: Color.blackColor(0.5),
            // fontFamily: 'Roboto',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: 'dashed',
            },
          },
        },
        {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: { color: Color.ccc },
          },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: (val: number) => {
              if (val === 0) return 0;
              return `${Number(val).toLocaleString()} `;
            },
            fontSize: 10,
            color: Color.blackColor(0.5),
            // fontFamily: 'Roboto',
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: Color.blackColor(0.08),
              width: 1,
              type: 'dashed',
            },
          },
        },
      ],
      series: [
        {
          name: '营业收入(亿元)',
          type: 'line',
          data: xData.rList,
        },
        {
          name: '招聘量(个)',
          yAxisIndex: 1,
          type: 'line',
          data: xData.nList,
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    setTimeout(() => {
      render();
    }, 200);
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [list, huringList]);

  return (
    <section className="huring-chart" ref={huringRef} />
  );
};

export default observer(HuringChart);
